import { Container, Stack, SxProps, useTheme } from "@mui/material";
import React, { FC } from "react";
import { useSxMerge } from "shared-ts-mui";
import { useTranslation } from "react-i18next";
import { ConfirmUserForm } from "shared-ts-ui-identity";
import { MyChimneyIcon } from "firefly-my-chimney-ts-shared";
import { useAppTheme } from "shared-ts-ui-app-theme-provider";
import { useLanguage } from "shared-ts-language";
import { useAppInfo } from "shared-ts-app-info";
import { NavigationLessAppPage } from "shared-ts-ui-app-boot";

export interface ConfirmUserProps {
  sx?: SxProps;
}

export const ConfirmUser: FC<ConfirmUserProps> = (props) => {
  const { t } = useTranslation("my-chimney-ts-translations");
  const theme = useTheme();
  const appInfo = useAppInfo();
  const { language, setLanguage } = useLanguage();
  const { themeName, setTheme } = useAppTheme();
  const sx = useSxMerge(props.sx, {
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  });

  return (
    <NavigationLessAppPage
      appName={t(appInfo.name as "My Chimney")}
      appIcon={
        <MyChimneyIcon
          mode={theme.palette.mode}
          color={"#99cccc"}
          style={{ maxHeight: "120px" }}
        />
      }
      language={language}
      onLanguageChange={setLanguage}
      themeName={themeName}
      onThemeChange={setTheme as React.Dispatch<React.SetStateAction<string>>}
      sx={props.sx}
    >
      <Container
        maxWidth={"xs"}
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Stack
          className={"AppLogin"}
          direction={"column"}
          useFlexGap
          gap={2}
          sx={sx}
        >
          <ConfirmUserForm />
        </Stack>
      </Container>
    </NavigationLessAppPage>
  );
};
